import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';

const NotFound = Loadable(lazy(() => import("./NotFound")));
const ForgotPassword = Loadable(lazy(() => import("./ForgotPassword")));
const JwtLogin = Loadable(lazy(() => import("./login/JwtLogin")));
const JwtRegister = Loadable(lazy(() => import("./register/JwtRegister")));
const PrivacyPolicy = Loadable(lazy(() => import("./PrivacyPolicy")));

const OnBoarding = Loadable(lazy(() => import("./onboarding")));

const sessionRoutes = [
    {
        path: '/signup',
        element: <JwtRegister />,
    },
    {
        path: '/signin',
        element: <JwtLogin />,
    },
    {
        path: '/forgot-password',
        element: <ForgotPassword />,
    },
    {
        path: '/404',
        element: <NotFound />,
    },
    {
        path: '/privacy-policy',
        element: <PrivacyPolicy />,
    },
    {
        path: '/get-started',
        element: <OnBoarding />,
    },
]

export default sessionRoutes
